import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Program from "./pages/Program";
import Penugasan from "./pages/Penugasan";
import Progress from "./pages/Progress";
import KendaliPenugasan from "./pages/KendaliPenugasan";
import Notifikasi from "./pages/Notifikasi";
import AuditInvestigasi from "./pages/AuditInvestigasi";
import AuditInvestigasiBaru from "./pages/AuditInvestigasiBaru";
import AuditInvestigasiDetail from "./pages/AuditInvestigasiDetail";
import KegiatanIrbansus from "./pages/KegiatanIrbansus";
import Pengaturan from "./pages/Pengaturan";
import PlaceholderPage from "./pages/PlaceholderPage";

function App() {
  useEffect(() => {
    document.title = "Dashboard Irbansus — Inspektorat Kab. Tasikmalaya";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <NotificationProvider>
            <Routes>
            <Route path="/login" element={<Login />} />

            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/program" element={<Program />} />
              <Route path="/penugasan" element={<Penugasan />} />
              <Route path="/telaahan-staff" element={<Penugasan defaultTab="telaahan" />} />
              <Route path="/progress" element={<Progress />} />
              <Route path="/kendali-penugasan" element={<KendaliPenugasan />} />
              <Route
                path="/audit"
                element={
                  <PlaceholderPage
                    title="Audit Investigasi & Tindak Lanjut"
                    subtitle="Modul utama audit investigasi, temuan, dan tindak lanjut."
                    testId="page-audit"
                  />
                }
              />
              <Route path="/audit-investigasi" element={<AuditInvestigasi />} />
              <Route path="/audit-investigasi/baru" element={<AuditInvestigasiBaru />} />
              <Route path="/audit-investigasi/:id" element={<AuditInvestigasiDetail />} />
              <Route path="/notifikasi" element={<Notifikasi />} />
              <Route path="/kegiatan-irbansus" element={<KegiatanIrbansus />} />
              <Route
                path="/pengaturan"
                element={<Pengaturan />}
              />
            </Route>

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </NotificationProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
